/**
 * React Query keys for billing.
 *
 * `all` is the invalidation root: a seat change, a cancellation and an
 * auto-renewal toggle all invalidate it, so every billing surface refreshes
 * without each mutation knowing which of them is mounted. The entity id is
 * part of every key because a session can switch acting entity without a
 * reload, and one startup's seat figures must never be served for another.
 */
export const billingKeys = {
  all: ['billing'] as const,
  overview: (entityId: string) => ['billing', 'overview', entityId] as const,
  invoices: (entityId: string) => ['billing', 'invoices', entityId] as const,
  catalogue: (entityId: string) => ['billing', 'catalogue', entityId] as const,
  checkoutReturn: (entityId: string) => ['billing', 'checkout-return', entityId] as const,
};
